// extracted by mini-css-extract-plugin
export default {"container":"Voting-module__container-L75qXO","content":"Voting-module__content-zjhE5I"};